import React from "react";
import axios from "../../../../common/axios";
import {isCancel} from "axios";

export const searchTestAssignmentsPaged = (params, handleTableData, handlePagingData, abortController) => {
    const {pageSize, pageNumber, ...testAssignmentSearchParams} = params;
    // console.log('testAssignmentSearchParams: ',testAssignmentSearchParams);
    if (pageSize && pageNumber && Object.keys(testAssignmentSearchParams).length > 0) {
        axios.post('/web/ui/test/searchTeacherTestAssignmentsPaged', testAssignmentSearchParams, {
            params: {
                pageSize: pageSize,
                pageNumber: pageNumber
            }, signal: abortController.signal
        }).then(response => {
                if (response && response.data) {
                    // console.log('response.data: ',response.data);
                    handleTableData(response.data.currPageContents);
                    const {pageSize, totalResults} = response.data;
                    let {currPage} = response.data;
                    handlePagingData({currPage, pageSize, totalResults});
                }
            }).catch((error) => {
                if(!isCancel(error)){
                    console.error('Missing params values for searchTeacherTestAssignments.');
                    displayToastMessage('Error finding test assignments', error.response.data.message, 'error', undefined, 10000);
                }
        }).finally(()=>{
            abortController = null;
        });
    } else {
        // setLoading(false);
    }
}